<template>
    <div v-if="isOrdbankWordClass(norskOrdbank, 'substantiv')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :partOfSpeachInfo="partOfSpeach" snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <template v-if="norskOrdbank.has_content">
        <div v-if="listLength(norskOrdbank.list) > 1" :id="getBlockId('ordbank-substantiv')" class="ordbank-table">
            <div class="ordbank-table desktop">
                <table class="inflection-table">
                    <thead>
                    <tr>
                        <th class="header rowspan-2" rowspan="2">{{ $t('message.ordbank_gender') }}</th>
                        <th class="header colspan-2" colspan="2">{{ $t('message.ordbank_singular') }}</th>
                        <th class="header colspan-2" colspan="2">{{ $t('message.ordbank_plural') }}</th>
                    </tr>
                    <tr>
                        <th class="header">{{ $t('message.ordbank_indefinite_form') }}</th>
                        <th class="header">{{ $t('message.ordbank_definite_form') }}</th>
                        <th class="header">{{ $t('message.ordbank_indefinite_form') }}</th>
                        <th class="header">{{ $t('message.ordbank_definite_form') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(sub_ord_info, noun_kjoenn_code) in norskOrdbank.list || []">
                        <tr v-for="(ord_info, word_index) in sub_ord_info.desktop || []">
                            <th
                                v-if="isFirstInList(sub_ord_info.desktop, word_index)"
                                :class="getBlockDivSubstHeaderClass(noun_kjoenn_code)"
                                :rowspan="listLength(sub_ord_info.desktop || [])"
                            >
                                <em>{{ $t(getKjoennTranslationCode(noun_kjoenn_code)) }}</em>
                            </th>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_ubestemt', false)"
                                :class="getSubstCellClass(ord_info, 'entall_ubestemt')"
                                :rowspan="ord_info.entall_ubestemt.rowspan || 1"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                            >
                                <div
                                    v-if="!isEmptyValue(ord_info.entall_ubestemt.oppslag)"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_singular_indefinite')"
                                >
                                    <span :id="getBlockSpeakerId((noun_kjoenn_code + '-' + word_index), 'entall_ubestemt')"><em>{{ ord_info.entall_ubestemt.kjoenn_prefix }}</em> {{ ord_info.entall_ubestemt.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_bestemt', false)"
                                :class="getSubstCellClass(ord_info, 'entall_bestemt')"
                                :rowspan="ord_info.entall_bestemt.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                            >
                                <div
                                    v-if="!isEmptyValue(ord_info.entall_bestemt.oppslag)"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_singular_definite')"
                                >
                                    <span :id="getBlockSpeakerId((noun_kjoenn_code + '-' + word_index), 'entall_bestemt')">{{ ord_info.entall_bestemt.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'flertall_ubestemt', false)"
                                :class="getSubstCellClass(ord_info, 'flertall_ubestemt')"
                                :rowspan="ord_info.flertall_ubestemt.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                            >
                                <div
                                    v-if="!isEmptyValue(ord_info.flertall_ubestemt.oppslag)"
                                    :rowspan="ord_info.rowspan"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_plural_indefinite')"
                                >
                                    <span :id="getBlockSpeakerId((noun_kjoenn_code + '-' + word_index), 'flertall_ubestemt')">{{ ord_info.flertall_ubestemt.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'flertall_bestemt', false)"
                                :class="getSubstCellClass(ord_info, 'flertall_bestemt')"
                                :rowspan="ord_info.flertall_bestemt.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                            >
                                <div
                                    v-if="!isEmptyValue(ord_info.flertall_bestemt.oppslag)"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_plural_definite')"
                                >
                                    <span :id="getBlockSpeakerId((noun_kjoenn_code + '-' + word_index), 'flertall_bestemt')">{{ ord_info.flertall_bestemt.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>

            <div class="ordbank-table mobile horisontal">
                <template v-for="(sub_ord_info, sub_word_index) in norskOrdbank.list || []">
                    <table class="inflection-table">
                    <tbody>
                        <tr>
                            <td colspan="2" class="mobile-spacer">
                                &nbsp;
                            </td>
                        </tr>
                        <template v-if="sub_ord_info.mobile.entall_ubestemt">
                            <tr>
                                <th :colspan="getSubstMobileHeaderColspan(sub_ord_info.mobile.entall_ubestemt)">{{ getSubstantivHeaderByCode(sub_word_index) }}</th>
                            </tr>
                            <tr>
                                <th>{{ $t('message.ordbank_singular_indefinite') }}</th>
                                <td
                                    v-for="(ord_info, word_index) in sub_ord_info.mobile.entall_ubestemt || []"
                                    :class="getSubstMobileCellClass(ord_info)"
                                    v-if="ord_info.show"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_singular_indefinite')"
                                    >
                                        <span :id="getBlockSpeakerId((sub_word_index + '-' + word_index), 'entall_ubestemt')"><em>{{ ord_info.kjoenn_prefix }}</em> {{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-if="sub_ord_info.mobile.entall_bestemt">
                            <tr>
                                <th>{{ $t('message.ordbank_singular_definite') }}</th>
                                <td
                                    v-for="(ord_info, word_index) in sub_ord_info.mobile.entall_bestemt || []"
                                    :class="getSubstMobileCellClass(ord_info)"
                                    v-if="ord_info.show"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_singular_definite')"
                                    >
                                        <span :id="getBlockSpeakerId((sub_word_index + '-' + word_index), 'entall_bestemt')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-if="sub_ord_info.mobile.flertall_ubestemt">
                            <tr>
                                <th>{{ $t('message.ordbank_plural_indefinite') }}</th>
                                <td
                                    v-for="(ord_info, word_index) in sub_ord_info.mobile.flertall_ubestemt || []"
                                    :class="getSubstMobileCellClass(ord_info)"
                                    v-if="ord_info.show"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_plural_indefinite')"
                                    >
                                        <span :id="getBlockSpeakerId((sub_word_index + '-' + word_index), 'flertall_ubestemt')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-if="sub_ord_info.mobile.flertall_bestemt">
                            <tr>
                                <th>{{ $t('message.ordbank_plural_definite') }}</th>
                                <td
                                    v-for="(ord_info, word_index) in sub_ord_info.mobile.flertall_bestemt || []"
                                    :class="getSubstMobileCellClass(ord_info)"
                                    v-if="ord_info.show"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_plural_definite')"
                                    >
                                        <span :id="getBlockSpeakerId((sub_word_index + '-' + word_index), 'flertall_bestemt')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    </table>
                </template>
            </div>
        </div>
        <div v-else-if="listLength(norskOrdbank.list) > 0">
            <div :id="getBlockId('ordbank-substantiv')" class="ordbank-table">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th class="header colspan-2" colspan="2">{{ $t('message.ordbank_singular') }}</th>
                            <th class="header colspan-2" colspan="2">{{ $t('message.ordbank_plural') }}</th>
                        </tr>
                        <tr>
                            <th class="header">{{ $t('message.ordbank_indefinite_form') }}</th>
                            <th class="header">{{ $t('message.ordbank_definite_form') }}</th>
                            <th class="header">{{ $t('message.ordbank_indefinite_form') }}</th>
                            <th class="header">{{ $t('message.ordbank_definite_form') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(sub_ord_info, sub_word_index) in norskOrdbank.list || []">
                            <tr v-for="(ord_info, word_index) in sub_ord_info.desktop || []">
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_ubestemt', false)"
                                    :class="getSubstCellClass(ord_info, 'entall_ubestemt')"
                                    :rowspan="ord_info.entall_ubestemt.rowspan || 1"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_ubestemt))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.entall_ubestemt.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_singular_indefinite')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'entall_ubestemt')"><em>{{ ord_info.entall_ubestemt.kjoenn_prefix }}</em> {{ ord_info.entall_ubestemt.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_bestemt', false)"
                                    :class="getSubstCellClass(ord_info, 'entall_bestemt')"
                                    :rowspan="ord_info.entall_bestemt.rowspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.entall_bestemt.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_singular_definite')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'entall_bestemt')">{{ ord_info.entall_bestemt.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'flertall_ubestemt', false)"
                                    :class="getSubstCellClass(ord_info, 'flertall_ubestemt')"
                                    :rowspan="ord_info.flertall_ubestemt.rowspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_ubestemt))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.flertall_ubestemt.oppslag)"
                                        :rowspan="ord_info.rowspan"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_plural_indefinite')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'flertall_ubestemt')">{{ ord_info.flertall_ubestemt.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'flertall_bestemt', false)"
                                    :class="getSubstCellClass(ord_info, 'flertall_bestemt')"
                                    :rowspan="ord_info.flertall_bestemt.rowspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info.flertall_bestemt))"
                                >
                                    <div
                                        v-if="!isEmptyValue(ord_info.flertall_bestemt.oppslag)"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_plural_definite')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'flertall_bestemt')">{{ ord_info.flertall_bestemt.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(sub_ord_info, sub_word_index) in norskOrdbank.list || []">
                            <tr>
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <template v-if="sub_ord_info.mobile.entall_ubestemt">
                                <tr>
                                    <th>{{ $t('message.ordbank_singular_indefinite') }}</th>
                                    <td
                                        v-for="(ord_info, word_index) in sub_ord_info.mobile.entall_ubestemt || []"
                                        :class="getSubstMobileCellClass(ord_info)"
                                        v-if="ord_info.show"
                                        :colspan="ord_info.colspan"
                                        @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    >
                                        <div
                                            v-if="!isEmptyValue(ord_info.oppslag)"
                                            :role="$t('message.ordbank_inflection')"
                                            :aria-label="$t('message.ordbank_singular_indefinite')"
                                        >
                                            <span :id="getBlockSpeakerId(word_index, 'entall_ubestemt')"><em>{{ ord_info.kjoenn_prefix }}</em> {{ ord_info.oppslag }}</span>
                                            <SpeakTextContent />
                                        </div>
                                        <div v-else class="mdash">
                                            &mdash;
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="sub_ord_info.mobile.entall_bestemt">
                                <tr>
                                    <th>{{ $t('message.ordbank_singular_definite') }}</th>
                                    <td
                                        v-for="(ord_info, word_index) in sub_ord_info.mobile.entall_bestemt || []"
                                        :class="getSubstMobileCellClass(ord_info)"
                                        v-if="ord_info.show"
                                        :colspan="ord_info.colspan"
                                        @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    >
                                        <div
                                            v-if="!isEmptyValue(ord_info.oppslag)"
                                            :role="$t('message.ordbank_inflection')"
                                            :aria-label="$t('message.ordbank_singular_definite')"
                                        >
                                            <span :id="getBlockSpeakerId(word_index, 'entall_bestemt')">{{ ord_info.oppslag }}</span>
                                            <SpeakTextContent />
                                        </div>
                                        <div v-else class="mdash">
                                            &mdash;
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="sub_ord_info.mobile.flertall_ubestemt">
                                <tr>
                                    <th>{{ $t('message.ordbank_plural_indefinite') }}</th>
                                    <td
                                        v-for="(ord_info, word_index) in sub_ord_info.mobile.flertall_ubestemt || []"
                                        :class="getSubstMobileCellClass(ord_info)"
                                        v-if="ord_info.show"
                                        :colspan="ord_info.colspan"
                                        @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    >
                                        <div
                                            v-if="!isEmptyValue(ord_info.oppslag)"
                                            :role="$t('message.ordbank_inflection')"
                                            :aria-label="$t('message.ordbank_plural_indefinite')"
                                        >
                                            <span :id="getBlockSpeakerId(word_index, 'flertall_ubestemt')">{{ ord_info.oppslag }}</span>
                                            <SpeakTextContent />
                                        </div>
                                        <div v-else class="mdash">
                                            &mdash;
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="sub_ord_info.mobile.flertall_bestemt">
                                <tr>
                                    <th>{{ $t('message.ordbank_plural_definite') }}</th>
                                    <td
                                        v-for="(ord_info, word_index) in sub_ord_info.mobile.flertall_bestemt || []"
                                        :class="getSubstMobileCellClass(ord_info)"
                                        v-if="ord_info.show"
                                        :colspan="ord_info.colspan"
                                        @focusin="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @focusout="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseenter="handleMouseOver(true, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                        @mouseleave="handleMouseOver(false, getBlockId('ordbank-substantiv'), getOrdInfoClass(ord_info))"
                                    >
                                        <div
                                            v-if="!isEmptyValue(ord_info.oppslag)"
                                            :role="$t('message.ordbank_inflection')"
                                            :aria-label="$t('message.ordbank_plural_definite')"
                                        >
                                            <span :id="getBlockSpeakerId(word_index, 'flertall_bestemt')">{{ ord_info.oppslag }}</span>
                                            <SpeakTextContent />
                                        </div>
                                        <div v-else class="mdash">
                                            &mdash;
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'verb')">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div
            :id="getBlockId('ordbank-verb')"
            class="ordbank-highlight"
            v-if="listLength(norskOrdbank.verb) > 0 && norskOrdbank.meta.verb.show || false"
        >
            <div class="ordbank-table desktop">
                <table class="inflection-table">
                    <thead>
                        <tr>
                            <th v-if="showOrdbankWordDataColumn('infinitiv')">{{ $t("message.ordbank_infinitive") }}</th>
                            <th v-if="showOrdbankWordDataColumn('presens')">{{ $t("message.ordbank_present") }}</th>
                            <th v-if="showOrdbankWordDataColumn('preteritum')">{{ $t("message.ordbank_preterite") }}</th>
                            <th v-if="showOrdbankWordDataColumn('supinum')">{{ $t("message.ordbank_present_perfect") }}</th>
                            <th v-if="showOrdbankWordDataColumn('imperativ')">{{ $t("message.ordbank_imperative") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ord_info, word_index) in norskOrdbank.verb || []">
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'infinitiv')"
                                :class="getClassByColumnInfo(ord_info.infinitiv)"
                                :rowspan="ord_info.infinitiv.rowspan || '1'"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.infinitiv))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.infinitiv))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.infinitiv))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.infinitiv))"
                            >
                                <div
                                    v-if="listLength(ord_info.infinitiv.oppslag_list) > 0"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_infinitive')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'infinitiv')">
                                        <template v-for="(ord, ord_index) in ord_info.infinitiv.oppslag_list"><template v-if="ord_index > 0">, </template><em>å</em> {{ ord }}</template>
                                    </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                                <ContentBlocks
                                    v-if="isKloyvdInfinitiv(ord_info.infinitiv)"
                                    id="kloyvd_infinitiv"
                                    :params="{}"
                                    :contentId="getBlockSpeakerId(word_index, 'kloyvd-infinitiv')"
                                />
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'presens')"
                                :class="getClassByColumnInfo(ord_info.presens || [])"
                                :rowspan="ord_info.presens.rowspan || '1'"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.presens || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.presens || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.presens || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.presens || []))"
                            >
                                <div
                                    v-if="ord_info.presens.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_present')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'presens')">{{ ord_info.presens.oppslag  || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'preteritum')"
                                :class="getClassByColumnInfo(ord_info.preteritum)"
                                :rowspan="ord_info.preteritum.rowspan || '1'"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.preteritum))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.preteritum))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.preteritum))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.preteritum))"
                            >
                                <div
                                    v-if="listLength(ord_info.preteritum.oppslag_list) > 0"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_preterite')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'preteritum')">
                                        <template v-for="(ord, ord_index) in ord_info.preteritum.oppslag_list"><template v-if="ord_index > 0">, </template>{{ ord }}</template>
                                    </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'supinum')"
                                :class="getClassByColumnInfo(ord_info.supinum)"
                                :rowspan="ord_info.supinum.rowspan || '1'"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.supinum))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.supinum))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.supinum))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.supinum))"
                            >
                                <div
                                    v-if="listLength(ord_info.supinum.oppslag_list) > 0"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_present_perfect')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'supinum')">
                                        <template v-for="(ord, ord_index) in ord_info.supinum.oppslag_list"><template v-if="ord_index > 0">, </template><em>har</em> {{ ord }}</template>
                                    </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'imperativ')"
                                :class="getClassByColumnInfo(ord_info.imperativ)"
                                :rowspan="ord_info.imperativ.rowspan || '1'"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.imperativ))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.imperativ))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.imperativ))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.imperativ))"
                            >
                                <div
                                    v-if="listLength(ord_info.imperativ.oppslag_list) > 0"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_imperative')"
                                >
                                <span :id="getBlockSpeakerId(word_index, 'imperativ')">
                                    <template v-for="(ord, ord_index) in ord_info.imperativ.oppslag_list"><template v-if="ord_index > 0">, </template>{{ ord }}<em>!</em></template>
                                </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="ordbank-table mobile vertical">
                <table class="inflection-table">
                    <tbody>
                    <template v-if="showOrdbankWordDataColumn('infinitiv')">
                        <tr>
                        <th class="header m-header">
                            {{ $t("message.ordbank_infinitive") }}
                        </th>
                        <template v-for="(ord_info, word_index) in norskOrdbank.verb_mob.infinitiv || []">
                            <td
                                v-if="showOrdbankWordDataColumn('infinitiv', ord_info)"
                                :class="getMobileClassByColumnInfo(ord_info)"
                                :colspan="ord_info.colspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                            >
                                <div
                                    v-if="listLength(ord_info.oppslag_list) > 0"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_infinitive')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'm-infinitiv')">
                                        <template v-for="(ord, ord_index) in ord_info.oppslag_list"><template v-if="ord_index > 0">, </template><em>å</em> {{ ord }}</template>
                                    </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                                <ContentBlocks
                                    v-if="isKloyvdInfinitiv(ord_info)"
                                    id="kloyvd_infinitiv"
                                    :contentId="getBlockSpeakerId(word_index, 'kloyvd-infinitiv-mob')"
                                    :params="getMobileKloyvdInfinitivParams()"
                                />
                            </td>
                        </template>
                        </tr>
                    </template>
                    <template v-if="showOrdbankWordDataColumn('presens')">
                        <tr>
                            <th class="header m-header">
                                {{ $t("message.ordbank_present") }}
                            </th>
                            <template v-for="(ord_info, word_index) in norskOrdbank.verb_mob.presens || []">
                                <td
                                    v-if="showOrdbankWordDataColumn('presens', ord_info)"
                                    :class="getMobileClassByColumnInfo(ord_info)"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="ord_info.oppslag"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_present')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'm-presens')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </template>
                        </tr>
                    </template>
                    <template v-if="showOrdbankWordDataColumn('preteritum')">
                        <tr>
                        <th class="header m-header">
                            {{ $t("message.ordbank_preterite") }}
                        </th>
                        <template v-for="(ord_info, word_index) in norskOrdbank.verb_mob.preteritum || []">
                            <td
                                v-if="showOrdbankWordDataColumn('preteritum', ord_info)"
                                :class="getMobileClassByColumnInfo(ord_info)"
                                :colspan="ord_info.colspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                            >
                                <div
                                    v-if="ord_info.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_preterite')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'm-preteritum')">{{ ord_info.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </template>
                        </tr>
                    </template>
                    <template v-if="showOrdbankWordDataColumn('supinum')">
                        <tr>
                        <th class="header m-header">
                            {{ $t("message.ordbank_present_perfect") }}
                        </th>
                        <template v-for="(ord_info, word_index) in norskOrdbank.verb_mob.supinum || []">
                            <td
                                v-if="showOrdbankWordDataColumn('supinum', ord_info)"
                                :class="getMobileClassByColumnInfo(ord_info)"
                                :colspan="ord_info.colspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                            >
                                <div
                                    v-if="listLength(ord_info.oppslag_list) > 0"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_present_perfect')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'm-supinum')">
                                        <template v-for="(ord, ord_index) in ord_info.oppslag_list"><template v-if="ord_index > 0">, </template><em>har</em> {{ ord }}</template>
                                    </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </template>
                        </tr>
                    </template>
                    <template v-if="showOrdbankWordDataColumn('imperativ')">
                        <tr>
                        <th class="header m-header">
                            {{ $t("message.ordbank_imperative") }}
                        </th>
                        <template v-for="(ord_info, word_index) in norskOrdbank.verb_mob.imperativ || []">
                            <td
                                v-if="showOrdbankWordDataColumn('imperativ', ord_info)"
                                :class="getMobileClassByColumnInfo(ord_info)"
                                :colspan="ord_info.colspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                            >
                                <div
                                    v-if="ord_info.oppslag_list"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_imperative')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'm-imperativ')">
                                        <template v-for="(ord, ord_index) in ord_info.oppslag_list"><template v-if="ord_index > 0">, </template>{{ ord }}<em>!</em></template>
                                    </span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </template>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>

            <details v-if="showVerbPartisipp()" :open="defaultOpenPartisipp">
                <summary
                    :data-hidetitle="$t('message.ordbank_click_for_hide_info')"
                    :data-showtitle="$t('message.ordbank_click_for_more_info')"
                >
                    <span class="show-inflection">{{ $t("message.ordbank_show_info_about_partisipp") }}</span>
                    <span class="hide-inflection">{{ $t("message.ordbank_hide_info_about_partisipp") }}</span>
                </summary>
                <div :class="getOrdbankTableBlockClass('partisipp', 'ordbank-table desktop')">
                    <table class="inflection-table">
                        <tr>
                            <th :colspan="getVerbHeaderPartisippColspan()" :class="getVerbHeaderPartisippClass()" v-if="showVerbPerfektumPartisipp()">{{ $t("message.ordbank_perfect_participle") }}</th>
                            <th class="header" v-if="showOrdbankWordDataColumn('partisipp_presens')" rowspan="2">{{ $t("message.ordbank_present_participle") }}</th>
                        </tr>
                        <tr>
                            <th class="header" v-if="showOrdbankWordDataColumn('partisipp_hanhun')">{{ $t("message.ordbank_mask_fem") }}</th>
                            <th class="header" v-if="showOrdbankWordDataColumn('partisipp_intet')">{{ $t("message.ordbank_kjoenn_noeyt") }}</th>
                            <th class="header" v-if="showOrdbankWordDataColumn('partisipp_bestemt')">{{ $t("message.ordbank_definite_form") }}</th>
                            <th class="header" v-if="showOrdbankWordDataColumn('partisipp_flertall')">{{ $t("message.ordbank_plural") }}</th>
                        </tr>

                        <tr v-for="(ord_info, word_index) in norskOrdbank.partisipp || []">
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'partisipp_hanhun') && showVerbPerfektumPartisipp()"
                                :class="getClassByColumnInfo(ord_info.partisipp_hanhun)"
                                :rowspan="ord_info.partisipp_hanhun.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_hanhun))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_hanhun))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_hanhun))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_hanhun))"
                            >
                                <div
                                    v-if="ord_info.partisipp_hanhun.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_mask_fem')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'partisipp_hanhun')">{{ ord_info.partisipp_hanhun.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'partisipp_intet') && showVerbPerfektumPartisipp()"
                                :class="getClassByColumnInfo(ord_info.partisipp_intet)"
                                :rowspan="ord_info.partisipp_intet.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_intet))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_intet))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_intet))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_intet))"
                            >
                                <div
                                    v-if="ord_info.partisipp_intet.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_kjoenn_noeyt')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'presens')">{{ ord_info.partisipp_intet.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'partisipp_bestemt') && showVerbPerfektumPartisipp()"
                                :class="getClassByColumnInfo(ord_info.partisipp_bestemt)"
                                :rowspan="ord_info.partisipp_bestemt.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_bestemt))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_bestemt))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_bestemt))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_bestemt))"
                            >
                                <div
                                    v-if="ord_info.partisipp_bestemt.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_definite_form')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'partisipp_bestemt')">{{ ord_info.partisipp_bestemt.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'partisipp_flertall') && showVerbPerfektumPartisipp()"
                                :class="getClassByColumnInfo(ord_info.partisipp_flertall)"
                                :rowspan="ord_info.partisipp_flertall.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_flertall))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_flertall))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_flertall))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_flertall))"
                            >
                                <div
                                    v-if="ord_info.partisipp_flertall.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_plural')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'partisipp_flertall')">{{ ord_info.partisipp_flertall.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'partisipp_presens')"
                                :class="getClassByColumnInfo(ord_info.partisipp_presens)"
                                :rowspan="ord_info.partisipp_presens.rowspan"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_presens))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_presens))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_presens))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info.partisipp_presens))"
                            >
                                <div
                                    v-if="ord_info.partisipp_presens.oppslag"
                                    :role="$t('message.ordbank_inflection')"
                                    :aria-label="$t('message.ordbank_present_participle')"
                                >
                                    <span :id="getBlockSpeakerId(word_index, 'partisipp_presens')">{{ ord_info.partisipp_presens.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="ordbank-table mobile vertical">
                    <table class="inflection-table">
                        <tbody>
                        <tr>
                            <th
                                v-if="showVerbPerfektumPartisipp()"
                                :class="getMobileHeaderClass()"
                                :colspan="getMobileHeaderColspan()"
                            >
                                {{ $t("message.ordbank_perfect_participle") }}
                            </th>
                        </tr>
                        <template v-if="showOrdbankWordDataColumn('partisipp_hanhun')">
                            <tr>
                            <th class="header m-header">
                                {{ $t("message.ordbank_mask_fem") }}
                            </th>
                            <template v-for="(ord_info, word_index) in norskOrdbank.partisipp_mob.partisipp_hanhun || []">
                                <td
                                    v-if="showOrdbankWordDataColumn('partisipp_hanhun', ord_info)"
                                    :class="getMobileClassByColumnInfo(ord_info)"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="ord_info.oppslag && ord_info.oppslag.trim() !== '-'"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_perfect_participle')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'm-partisipp_hanhun')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </template>
                            </tr>
                        </template>
                        <template v-if="showOrdbankWordDataColumn('partisipp_intet')">
                            <tr>
                            <th class="header m-header">
                                {{ $t("message.ordbank_kjoenn_noeyt") }}
                            </th>
                            <template v-for="(ord_info, word_index) in norskOrdbank.partisipp_mob.partisipp_intet || []">
                                <td
                                    v-if="showOrdbankWordDataColumn('partisipp_intet', ord_info)"
                                    :class="getMobileClassByColumnInfo(ord_info)"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="ord_info.oppslag"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_kjoenn_noeyt')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'm-partisipp_intet')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </template>
                            </tr>
                        </template>
                        <template v-if="showOrdbankWordDataColumn('partisipp_bestemt')">
                            <tr>
                            <th class="header m-header">
                                {{ $t("message.ordbank_definite") }}
                            </th>
                            <template v-for="(ord_info, word_index) in norskOrdbank.partisipp_mob.partisipp_bestemt || []">
                                <td
                                    v-if="showOrdbankWordDataColumn('partisipp_bestemt', ord_info)"
                                    :class="getMobileClassByColumnInfo(ord_info)"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="ord_info.oppslag"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_definite')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'm-partisipp_bestemt')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </template>
                            </tr>
                        </template>
                        <template v-if="showOrdbankWordDataColumn('partisipp_flertall')">
                            <tr>
                            <th class="header m-header">
                                {{ $t("message.ordbank_plural") }}
                            </th>
                            <template v-for="(ord_info, word_index) in norskOrdbank.partisipp_mob.partisipp_flertall || []">
                                <td
                                    v-if="showOrdbankWordDataColumn('partisipp_flertall', ord_info)"
                                    :class="getMobileClassByColumnInfo(ord_info)"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="ord_info.oppslag"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_plural')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'm-partisipp_flertall')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </template>
                            </tr>
                        </template>
                        <tr>
                            <th :colspan="getMobilePartisippHeaderColspan()" class="mobile-spacer">
                                {{ $t('message.ordbank_present_participle') }}
                            </th>
                        </tr>
                        <template v-if="showOrdbankWordDataColumn('partisipp_presens')">
                            <tr>
                            <th class="cell header m-header">&nbsp;</th>
                            <template v-for="(ord_info, word_index) in norskOrdbank.partisipp_mob.partisipp_presens || []">
                                <td
                                    v-if="showOrdbankWordDataColumn('partisipp_presens', ord_info)"
                                    :class="getMobileClassByColumnInfo(ord_info)"
                                    :colspan="ord_info.colspan"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-verb'), getOrdInfoClass(ord_info))"
                                >
                                    <div
                                        v-if="ord_info.oppslag"
                                        :role="$t('message.ordbank_inflection')"
                                        :aria-label="$t('message.ordbank_present_participle')"
                                    >
                                        <span :id="getBlockSpeakerId(word_index, 'm-partisipp_presens')">{{ ord_info.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </template>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </details>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'adjektiv') || isOrdbankWordClass(norskOrdbank, 'determinativ')" class="responsive adjektiv">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div v-if="listLength(norskOrdbank.grunn) > 0" :id="getBlockId('ordbank-adjektiv')" class="ordbank-highlight">
            <div class="ordbank-table">
                <div :class="getAdjectiveDesktopBlockClass()">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th
                                :colspan="getAdjektivDesktopHeaderColspan()"
                                :class="getAdjektivDesktopHeaderClass()"
                                v-if="hasMetaShowCol('entall_hanhun') || hasMetaShowCol('entall_intet') || hasMetaShowCol('entall_bestemt')">
                                {{ $t("message.ordbank_singular") }}
                            </th>
                            <th rowspan="2" class="header" v-if="hasMetaShowCol('flertall')">{{ $t("message.ordbank_plural") }}</th>
                        </tr>
                        <tr>
                            <th class="header" v-if="hasMetaShowCol('entall_han')">{{ $t("message.ordbank_kjoenn_mask") }}</th>
                            <th class="header" v-if="hasMetaShowCol('entall_hun')">{{ $t("message.ordbank_kjoenn_fem") }}</th>
                            <th class="header" v-if="hasMetaShowCol('entall_hanhun')">{{ $t("message.ordbank_mask_fem") }}</th>
                            <th class="header" v-if="hasMetaShowCol('entall_intet')">{{ $t("message.ordbank_kjoenn_noeyt") }}</th>
                            <th class="header" v-if="hasMetaShowCol('entall_bestemt')">{{ $t("message.ordbank_definite_form") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.grunn || []">
                            <tr>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_han')"
                                    :rowspan="ord_info.entall_han.rowspan"
                                    :class="getClassByColumnInfo(ord_info.entall_han)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                >
                                    <div v-if="ord_info.entall_han.oppslag && ord_info.entall_han.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_hun')"
                                    :rowspan="ord_info.entall_hun.rowspan"
                                    :class="getClassByColumnInfo(ord_info.entall_hun)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                >
                                    <div v-if="ord_info.entall_hun.oppslag && ord_info.entall_hun.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_hanhun')"
                                    :rowspan="ord_info.entall_hanhun.rowspan"
                                    :class="getClassByColumnInfo(ord_info.entall_hanhun)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                >
                                    <div v-if="ord_info.entall_hanhun.oppslag && ord_info.entall_hanhun.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hanhun')">{{ ord_info.entall_hanhun.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_intet')"
                                    :rowspan="ord_info.entall_intet.rowspan"
                                    :class="getClassByColumnInfo(ord_info.entall_intet)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                >
                                    <div v-if="ord_info.entall_intet.oppslag">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'entall_bestemt')"
                                    :rowspan="ord_info.entall_bestemt.rowspan"
                                    :class="getClassByColumnInfo(ord_info.entall_bestemt)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                >
                                    <div v-if="ord_info.entall_bestemt.oppslag">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_bestemt')">{{ ord_info.entall_bestemt.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                                <td
                                    v-if="showOrdbankWordDataTableColumn(ord_info, 'flertall')"
                                    :rowspan="ord_info.flertall.rowspan"
                                    :class="getClassByColumnInfo(ord_info.flertall)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                >
                                    <div v-if="ord_info.flertall.oppslag">
                                        <span :id="getBlockSpeakerId(word_index, 'flertall')">{{ ord_info.flertall.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.grunn || []">
                            <tr v-if="(word_index || 0) > 0">
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr v-if="showAdjectiveHeader('grunn', 'entall_han')">
                                <th>
                                    {{ $t("message.ordbank_singular_mask") }}
                                </th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_han)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_han))"
                                >
                                    <div v-if="ord_info.entall_han.oppslag && ord_info.entall_han.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showAdjectiveHeader('grunn', 'entall_hun')">
                                <th>
                                    {{ $t("message.ordbank_singular_fem") }}
                                </th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_hun)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hun))"
                                >
                                    <div v-if="ord_info.entall_hun.oppslag && ord_info.entall_hun.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showAdjectiveHeader('grunn', 'entall_hanhun')">
                                <th>
                                    {{ $t("message.ordbank_singular_mask_fem") }}
                                </th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_hanhun)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_hanhun))"
                                >
                                    <div v-if="ord_info.entall_hanhun.oppslag && ord_info.entall_hanhun.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hanhun')">{{ ord_info.entall_hanhun.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showAdjectiveHeader('grunn', 'entall_intet')">
                                <th>{{ $t("message.ordbank_singular_kjoenn_noeyt") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_intet)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_intet))"
                                >
                                    <div v-if="ord_info.entall_intet.oppslag && ord_info.entall_intet.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showAdjectiveHeader('grunn', 'entall_bestemt')">
                                <th>{{ $t("message.ordbank_singular_definite_form") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_bestemt)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.entall_bestemt))"
                                >
                                    <div v-if="ord_info.entall_bestemt.oppslag && ord_info.entall_bestemt.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_bestemt')">{{ ord_info.entall_bestemt.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showAdjectiveHeader('grunn', 'flertall')">
                                <th>{{ $t("message.ordbank_plural") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.flertall)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.flertall))"
                                >
                                    <div v-if="ord_info.flertall.oppslag && ord_info.flertall.oppslag !== '-'">
                                        <span :id="getBlockSpeakerId(word_index, 'flertall')">{{ ord_info.flertall.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <br />
            <div class="ordbank-table" v-if="showAdditionalInflection()">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                        <th :colspan="getAdjectiveDegreeHeaderLength()" class="header">{{ $t("message.ordbank_degree") }}</th>
                        </tr>
                        <tr>
                            <th class="header" v-if="showAdjectiveDegreeHeader('grunnform')">{{ $t("message.ordbank_positive") }}</th>
                            <th class="header" v-if="showAdjectiveDegreeHeader('grad_komparativ')">{{ $t("message.ordbank_comparative") }}</th>
                            <th class="header" v-if="showAdjectiveDegreeHeader('grad_superlativ')">{{ $t("message.ordbank_superlative") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ord_info, word_index) in norskOrdbank.gradboying || []">
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'grunnform') && getOrdInfoRowspan(ord_info.grunnform || [])"
                                :class="getClassByColumnInfo(ord_info.grunnform)"
                                :rowspan="getOrdInfoRowspan(ord_info.grunnform || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                            >
                                <div v-if="ord_info.grunnform.oppslag">
                                    <span :id="getBlockSpeakerId(word_index, 'grunnform')">{{ ord_info.grunnform.oppslag }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'grad_komparativ')"
                                :class="getClassByColumnInfo(ord_info.grad_komparativ || [])"
                                :rowspan="getOrdInfoRowspan(ord_info.grad_komparativ || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                            >
                                <div v-if="ord_info.grad_komparativ.is_grunnform  == false">
                                    <template v-if="ord_info.grad_komparativ.oppslag">
                                        <span :id="getBlockSpeakerId(word_index, 'grad_komparativ')">{{ ord_info.grad_komparativ.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </template>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </div>
                                <div v-else>
                                    <template v-if="ord_info.grunnform.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'grad_komparativ')"><em>{{ lang_mer }}</em> {{ ord_info.grunnform.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </template>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataTableColumn(ord_info, 'grad_superlativ')"
                                :class="getClassByColumnInfo(ord_info.grad_superlativ || [])"
                                :rowspan="getOrdInfoRowspan(ord_info.grad_superlativ || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                            >
                                <div v-if="ord_info.grad_superlativ.is_grunnform == false">
                                    <template v-if="ord_info.grad_superlativ.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'grad_superlativ')">{{ ord_info.grad_superlativ.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </template>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </div>
                                <div v-else>
                                    <template v-if="ord_info.grunnform.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'grad_superlativ')"><em>{{ lang_mest }}</em> {{ ord_info.grunnform.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </template>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.gradboying || []">
                            <tr v-if="(word_index || 0) > 0">
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr v-if="showOrdbankWordDataTableColumn(ord_info, 'grunnform')">
                                <th>
                                    {{ $t("message.ordbank_positive_degree") }}
                                </th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.grunnform)"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grunnform))"
                                >
                                    <div v-if="ord_info.grunnform.oppslag">
                                        <span :id="getBlockSpeakerId(word_index, 'grunnform')">{{ ord_info.grunnform.oppslag }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="showOrdbankWordDataTableColumn(ord_info, 'grad_komparativ')">
                                <th>
                                    {{ $t("message.ordbank_comparative_degree") }}
                                </th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.grad_komparativ || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                >
                                    <div v-if="ord_info.grad_komparativ.is_grunnform  === false">
                                        <template v-if="(ord_info.grad_komparativ.oppslag || '').trim() !== '-'">
                                            <span :id="getBlockSpeakerId(word_index, 'grad_komparativ')">{{ ord_info.grad_komparativ.oppslag || '' }}</span>
                                            <SpeakTextContent  />
                                        </template>
                                        <div v-else class="mdash">
                                            &mdash;
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span :id="getBlockSpeakerId(word_index, 'grad_komparativ')"><em>{{ lang_mer }}</em> {{ ord_info.grunnform.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showOrdbankWordDataTableColumn(ord_info, 'grad_superlativ')">
                                <th>{{ $t("message.ordbank_superlative_degree") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.grad_superlativ || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adjektiv'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                >
                                    <div v-if="ord_info.grad_superlativ.is_grunnform == false">
                                        <span :id="getBlockSpeakerId(word_index, 'grad_superlativ')">{{ ord_info.grad_superlativ.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </div>
                                    <div v-else>
                                        <span :id="getBlockSpeakerId(word_index, 'grad_superlativ')"><em>{{ lang_mest }}</em> {{ ord_info.grunnform.oppslag || '' }}</span>
                                        <SpeakTextContent  />
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'adverb')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div v-if="norskOrdbank.has_content" :id="getBlockId('ordbank-adverb')" class="ordbank-highlight">
            <div class="ordbank-table">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th
                                colspan="3"
                                class="header">
                                {{ $t("message.ordbank_degree") }}
                            </th>
                        </tr>
                        <tr>
                            <th class="header">{{ $t("message.ordbank_positive") }}</th>
                            <th class="header">{{ $t("message.ordbank_comparative") }}</th>
                            <th class="header">{{ $t("message.ordbank_superlative") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.grunn || []">
                        <tr>
                            <td
                                v-if="ord_info.grunnform.show"
                                :rowspan="ord_info.grunnform.rowspan"
                                :class="getClassByColumnInfo(ord_info.grunnform || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                            >
                                <div v-if="ord_info.grunnform.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_hanhun')">{{ ord_info.grunnform.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="ord_info.grad_komparativ.show"
                                :rowspan="ord_info.grad_komparativ.rowspan"
                                :class="getClassByColumnInfo(ord_info.grad_komparativ || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                            >
                                <div v-if="ord_info.grad_komparativ.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'grad_komparativ')">{{ ord_info.grad_komparativ.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="ord_info.grad_superlativ.show"
                                :rowspan="ord_info.grad_superlativ.rowspan"
                                :class="getClassByColumnInfo(ord_info.grad_superlativ || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                            >
                                <div v-if="ord_info.grad_superlativ.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'superlativ')">{{ ord_info.grad_superlativ.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.grunn || []">
                            <tr v-if="(word_index || 0) > 0">
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <th
                                    colspan="2"
                                    class="header">
                                    {{ $t("message.ordbank_degree") }}
                                </th>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_positive") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.grunnform || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grunnform))"
                                >
                                    <div v-if="ord_info.grunnform.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hanhun')">{{ ord_info.grunnform.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_comparative") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.grad_komparativ || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_komparativ || []))"
                                >
                                    <div v-if="ord_info.grad_komparativ.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'grad_komparativ')">{{ ord_info.grad_komparativ.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_superlative") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.grad_superlativ || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-adverb'), getOrdInfoClass(ord_info.grad_superlativ || []))"
                                >
                                    <div v-if="ord_info.grad_superlativ.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'superlativ')">{{ ord_info.grad_superlativ.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'personlig pronomen')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div v-if="norskOrdbank.has_content" :id="getBlockId('ordbank-p-pron')" class="ordbank-highlight">
            <div class="ordbank-table">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th class="header">{{ $t("message.ordbank_subject_form") }}</th>
                            <th class="header">{{ $t("message.ordbank_object_form") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(ord_info, word_index, row_index) in norskOrdbank.pronomen || []" v-if="hasOrdInfoFields(ord_info, ['nominativ', 'objektsform'])">
                            <td
                                :class="getClassByColumnInfo(ord_info.nominativ || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                            >
                                <div v-if="ord_info.nominativ.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'nominativ')">{{ ord_info.nominativ.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.objektsform || [])"
                                data-header="objektsform"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                            >
                                <div v-if="ord_info.objektsform.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'objektsform')">{{ ord_info.objektsform.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.pronomen || []" v-if="hasOrdInfoFields(ord_info, ['nominativ', 'objektsform'])">
                            <tr v-if="(word_index || 0) > 0">
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_subject_form") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.nominativ || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.nominativ))"
                                >
                                    <div v-if="ord_info.nominativ.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'nominativ')">{{ ord_info.nominativ.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_object_form") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.objektsform || [])"
                                    data-header="objektsform"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-p-pron'), getOrdInfoClass(ord_info.objektsform || []))"
                                >
                                    <div v-if="ord_info.objektsform.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'objektsform')">{{ ord_info.objektsform.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'spørrepronomen')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div v-if="norskOrdbank.has_content" :id="getBlockId('ordbank-sp-pron')" class="ordbank-highlight">
            <div class="ordbank-table" v-if="listLength(norskOrdbank.pronomen) > 0">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th colspan="3" class="header">{{ $t("message.ordbank_singular") }}</th>
                            <th rowspan="2" class="header">{{ $t("message.ordbank_plural") }}</th>
                        </tr>
                        <tr>
                            <th class="header">{{ $t("message.ordbank_kjoenn_mask") }}</th>
                            <th class="header">{{ $t("message.ordbank_kjoenn_fem") }}</th>
                            <th class="header">{{ $t("message.ordbank_kjoenn_noeyt") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-if="hasResultRowFields(ord_info, ['entall_han', 'entall_hun', 'entall_intet', 'flertall'])"
                            v-for="(ord_info, word_index, row_index) in norskOrdbank.pronomen || []"
                        >
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                            >
                                <div v-if="ord_info.entall_han.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                            >
                                <div v-if="ord_info.entall_hun.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                            >
                                <div v-if="ord_info.entall_intet.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.flertall || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                            >
                                <div v-if="ord_info.flertall.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'flertall')">{{ ord_info.flertall.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template
                            v-if="hasResultRowFields(ord_info, ['entall_han', 'entall_hun', 'entall_intet', 'flertall'])"
                            v-for="(ord_info, word_index, row_index) in norskOrdbank.pronomen || []"
                        >
                            <tr>
                                <th>{{ $t("message.ordbank_singular_mask") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_han))"
                                >
                                    <div v-if="ord_info.entall_han.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_fem") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_hun || []))"
                                >
                                    <div v-if="ord_info.entall_hun.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_noeyt") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.entall_intet || []))"
                                >
                                    <div v-if="ord_info.entall_intet.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_plural") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.flertall || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-sp-pron'), getOrdInfoClass(ord_info.flertall || []))"
                                >
                                    <div v-if="ord_info.flertall.oppslag || ''">
                                        <span :id="getBlockSpeakerId(word_index, 'flertall')">{{ ord_info.flertall.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'determinativ possessiv')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div v-if="norskOrdbank.has_content" :id="getBlockId('ordbank-det-poss')" class="ordbank-highlight">

            <div class="ordbank-table desktop">
                <table class="inflection-table">
                    <thead>
                    <tr>
                        <th colspan="3" class="header">{{ $t("message.ordbank_singular") }}</th>
                        <th rowspan="2" class="header">{{ $t("message.ordbank_plural") }}</th>
                    </tr>
                    <tr>
                        <th class="header">{{ $t("message.ordbank_kjoenn_mask") }}</th>
                        <th class="header">{{ $t("message.ordbank_kjoenn_fem") }}</th>
                        <th class="header">{{ $t("message.ordbank_kjoenn_noeyt") }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(ord_info, word_index) in norskOrdbank.list || []">
                        <td
                            :class="getClassByColumnInfo(ord_info.entall_han || [])"
                            data-header="entall hankjønn"
                            @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                            @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                            @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                            @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                        >
                            <div v-if="ord_info.entall_han.oppslag || ''">
                                <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                <SpeakTextContent />
                            </div>
                            <div v-else class="mdash">
                                &mdash;
                            </div>
                        </td>
                        <td
                            :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                            data-header="entall hunkjønn"
                            @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                            @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                            @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                            @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                        >
                            <div v-if="ord_info.entall_hun.oppslag || ''">
                                <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                <SpeakTextContent />
                            </div>
                            <div v-else class="mdash">
                                &mdash;
                            </div>
                        </td>
                        <td
                            :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                            data-header="entall intetkjønn"
                            @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                            @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                            @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                            @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                        >
                            <div v-if="ord_info.entall_intet.oppslag || ''">
                                <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                <SpeakTextContent />
                            </div>
                            <div v-else class="mdash">
                                &mdash;
                            </div>
                        </td>
                        <td
                            :class="getClassByColumnInfo(ord_info.flertall || [])"
                            data-header="flertall"
                            @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                            @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                            @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                            @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                        >
                            <div v-if="ord_info.flertall.oppslag || ''">
                                <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.flertall.oppslag || '' }}</span>
                                <SpeakTextContent />
                            </div>
                            <div v-else class="mdash">
                                &mdash;
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="ordbank-table mobile horisontal">
                <table class="inflection-table">
                    <tbody>
                    <template v-for="(ord_info, word_index) in norskOrdbank.list || []">
                        <tr v-if="(word_index || 0) > 0">
                            <td colspan="2" class="mobile-spacer">
                                &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("message.ordbank_singular_mask") }}</th>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_han))"
                            >
                                <div v-if="ord_info.entall_han.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("message.ordbank_singular_fem") }}</th>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_hun || []))"
                            >
                                <div v-if="ord_info.entall_hun.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("message.ordbank_singular_noeyt") }}</th>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.entall_intet || []))"
                            >
                                <div v-if="ord_info.entall_intet.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("message.ordbank_plural") }}</th>
                            <td
                                :class="getClassByColumnInfo(ord_info.flertall || [])"
                                data-header="flertall"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-poss'), getOrdInfoClass(ord_info.flertall || []))"
                            >
                                <div v-if="ord_info.flertall.oppslag || ''">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.flertall.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'determinativ demonstrativ')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div :id="getBlockId('ordbank-det-dem')" class="ordbank-highlight">
            <div class="ordbank-table" v-if="listLength(norskOrdbank.det_dem || []) > 0">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th colspan="4" class="header">{{ $t("message.ordbank_singular") }}</th>
                            <th rowspan="2" class="header">{{ $t("message.ordbank_plural") }}</th>
                        </tr>
                        <tr>
                            <th class="header">{{ $t("message.ordbank_kjoenn_mask") }}</th>
                            <th class="header">{{ $t("message.ordbank_kjoenn_fem") }}</th>
                            <th class="header">{{ $t("message.ordbank_kjoenn_noeyt") }}</th>
                            <th class="header">{{ $t("message.ordbank_definite_form") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ord_info, word_index, row_index) in norskOrdbank.det_dem || []">
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                            >
                                <div v-if="textHasContent(ord_info.entall_han.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                            >
                                <div v-if="textHasContent(ord_info.entall_hun.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                            >
                                <div v-if="textHasContent(ord_info.entall_intet.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_bestemt || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                            >
                                <div v-if="textHasContent(ord_info.entall_bestemt.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_bestemt')">{{ ord_info.entall_bestemt.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.flertall || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                            >
                                <div v-if="textHasContent(ord_info.flertall.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'flertall')">{{ ord_info.flertall.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.det_dem || []">
                            <tr v-if="(word_index || 0) > 0">
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_mask") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_han))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_han.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_fem") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_hun || []))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_hun.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_noeyt") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_intet || []))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_intet.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_definite_form") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_bestemt || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.entall_bestemt || []))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_bestemt.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_bestemt')">{{ ord_info.entall_bestemt.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_plural") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.flertall || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-det-dem'), getOrdInfoClass(ord_info.flertall || []))"
                                >
                                    <div v-if="textHasContent(ord_info.flertall.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'flertall')">{{ ord_info.flertall.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'determinativ kvantor')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <div v-if="norskOrdbank.has_content" :id="getBlockId('ordbank-kvantor')" class="ordbank-highlight">
            <div class="ordbank-table" v-if="listLength(norskOrdbank.kvantor || []) > 0">
                <div class="ordbank-table desktop">
                    <table class="inflection-table">
                        <thead>
                        <tr>
                            <th colspan="3" class="header">{{ $t("message.ordbank_singular") }}</th>
                            <th rowspan="2" class="header" v-if="showOrdbankWordDataColumn('flertall')">{{ $t("message.ordbank_plural") }}</th>
                        </tr>
                        <tr>
                            <th class="header">{{ $t("message.ordbank_kjoenn_mask") }}</th>
                            <th class="header">{{ $t("message.ordbank_kjoenn_fem") }}</th>
                            <th class="header">{{ $t("message.ordbank_kjoenn_noeyt") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ord_info, word_index, row_index) in norskOrdbank.kvantor || []">
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                            >
                                <div v-if="textHasContent(ord_info.entall_han.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                            >
                                <div v-if="textHasContent(ord_info.entall_hun.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                            >
                                <div v-if="textHasContent(ord_info.entall_intet.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                            <td
                                v-if="showOrdbankWordDataColumn('flertall', ord_info.flertall)"
                                :class="getClassByColumnInfo(ord_info.flertall || [])"
                                @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                            >
                                <div v-if="textHasContent(ord_info.flertall.oppslag || '')">
                                    <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.flertall.oppslag || '' }}</span>
                                    <SpeakTextContent />
                                </div>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="ordbank-table mobile horisontal">
                    <table class="inflection-table">
                        <tbody>
                        <template v-for="(ord_info, word_index) in norskOrdbank.kvantor || []">
                            <tr v-if="(word_index || 0) > 0">
                                <td colspan="2" class="mobile-spacer">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_mask") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_han || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_han))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_han.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_han')">{{ ord_info.entall_han.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_fem") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_hun || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_hun || []))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_hun.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_hun')">{{ ord_info.entall_hun.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t("message.ordbank_singular_noeyt") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.entall_intet || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.entall_intet || []))"
                                >
                                    <div v-if="textHasContent(ord_info.entall_intet.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.entall_intet.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="showOrdbankWordDataColumn('flertall')">
                                <th>{{ $t("message.ordbank_plural") }}</th>
                                <td
                                    :class="getClassByColumnInfo(ord_info.flertall || [])"
                                    @focusin="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                    @focusout="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                    @mouseenter="handleMouseOver(true, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                    @mouseleave="handleMouseOver(false, getBlockId('ordbank-kvantor'), getOrdInfoClass(ord_info.flertall || []))"
                                >
                                    <div v-if="textHasContent(ord_info.flertall.oppslag || '')">
                                        <span :id="getBlockSpeakerId(word_index, 'entall_intet')">{{ ord_info.flertall.oppslag || '' }}</span>
                                        <SpeakTextContent />
                                    </div>
                                    <div v-else class="mdash">
                                        &mdash;
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'navn')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'prefiks')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'refleksivt pronomen')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'resiprokt pronomen')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'preposisjon')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'subjunksjon')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'konjunksjon')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'interjeksjon')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'i sammensetning')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'forkortelse')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'symbol')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
    </div>
    <div v-else-if="isOrdbankWordClass(norskOrdbank, 'lexin')" class="responsive">
        <template v-if="showHeader">
            <NorskOrdbankResultHeader :snId="snId" :norskOrdbank="norskOrdbank" :showLemma="showLemma"></NorskOrdbankResultHeader>
        </template>
        <LexinBoyingResult
            :boyingResult="getBoyingResult()"
            :id="getOrdbankId(norskOrdbank, 'lexin-boying')"
            :languageCode="norskOrdbank.language_code"
            :showHeader="false"
        />
    </div>

</template>
<script>

import SpeakTextContent from "./SpeakTextContent.vue";
import LexinBoyingResult from "./LexinBoyingResult.vue";
import NorskOrdbankResultHeader from "./NorskOrdbankResultHeader.vue";
import ContentBlocks from "./ContentBlocks.vue";

export default {
	name: 'norskOrdbankResult',
    components: {
        ContentBlocks,
        SpeakTextContent,
        LexinBoyingResult,
        NorskOrdbankResultHeader
    },
    data(){
        return {
            lang_mer: "mer",
            lang_mest: "mest"
        }
    },
	props: {
        'snId': {
            required: false,
            default: () => (0)
        },
        'norskOrdbank': {
            required: false,
            default: () => ({})
        },
        'norskOrdbankIndex': {
            required: false,
            default: ''
        },
        'partOfSpeach': {
            required: false,
            default: () => ({})
        },
        'defaultOpen': {
            required: false,
            default: false
        },
        'defaultOpenPartisipp': {
            required: false,
            default: true
        },
        'showHeader': {
            required: false,
            default: true
        },
        'showBody': {
            required: false,
            default: true
        },
        'showLemma': {
            required: false,
            default: false
        },
        'showPronunciationHeader': {
            required: false,
            default: true
        }
	},
	mounted(){
        if (this.norskOrdbank.language_code == 'nno') {
            this.lang_mer = "meir";
            this.lang_mest = "mest";
        }
	},
	methods:{
        openDialogKey(row_info, event) {
            // keycode for space and enter should open dialog.
            if (event.keyCode == 13 || event.keyCode == 32) {
                event.preventDefault();
                this.openDialog(row_info, event);
            }
        },
        openDialog(row_info, event) {
            let dialogElements = event.target.closest('td').querySelectorAll('dialog');
            if (dialogElements) {
                let dialogElement = dialogElements.item(0);
                if (dialogElement.open === true) {
                    dialogElement.open = false;
                } else {
                    dialogElement.open = true;
                    document.addEventListener('click', this.handleCloseDialogClick);
                    document.addEventListener('keydown', this.handleCloseDialogClick);
                }
            }
        },
        handleCloseDialogClick(e) {
            let eTargetId = '';
            if (e.constructor.name == 'KeyboardEvent') {
                // Only handle escape character
                if (e.keyCode != 27) {
                    return;
                }
            } else {
                let eTarget = e.target.closest('span.kloyvd-infinitiv-link');
                if (!eTarget) {
                    eTarget = e.target.closest('dialog');
                }

                if (eTarget) {
                    eTargetId = eTarget.closest('td').querySelectorAll('dialog').item(0).id;
                }
            }

            let isRemoved = true;
            this.$refs.dialogs.forEach(dialog => {
                if (dialog.id != eTargetId) {
                    dialog.open = false;
                } else {
                    isRemoved = false;
                }
            });

            if (isRemoved) {
                document.removeEventListener('click', this.handleCloseDialogClick);
                document.removeEventListener('keydown', this.handleCloseDialogClick);
            }
        },
        closeDialogs(event) {
            let dialogElements = event.target.closest('body').querySelectorAll('dialog');

            for (let i = 0; i < dialogElements.length; i++) {
                let item = dialogElements[i];
                item.open = false;
            }
        },
        textHasContent (value) {
            if (value.replace('-', '').trim() == '') {
                return false;
            }
            return true;
        },
        getBlockId(name) {
            let blockId = "block-" + name;
            if (typeof this.norskOrdbank == "object" && this.norskOrdbank.lemma_id != undefined) {
                blockId += "-" + this.norskOrdbank.lemma_id;
            }

            if (this.norskOrdbankIndex != undefined) {
                blockId += "-" + this.norskOrdbankIndex;
            }

            return blockId;
        },
        getBlockSpeakerId(word_index, fieldName) {
            let id = this.getBlockId("ordbank-speaker-id");
            id += "-" + word_index.toString() + "-" + fieldName.toString();

            return id;
        },
        getBlockDivSubstHeaderClass(word_index) {
            let className = 'header cell-header';
            if (this.norskOrdbank.list[word_index] != undefined) {
                className += " " + word_index;
            }

            return className;
        },
        getSubstMobileHeaderColspan(ord_info_list) {
            let value = 1;
            let listLength = this.listLength(ord_info_list);
            if ( listLength > 0) {
                value += listLength;
            }

            return value;
        },
        getSubstMobileCellClass(ord_info) {
            let className = 'cell';
            if (typeof ord_info == "object" &&
                ord_info.class != undefined) {
                className += ' ' + ord_info.class;
            }

            return className;
        },
        getSubstCellClass(ord_info, field_name) {
            let className = 'cell';
            if (typeof ord_info == "object" &&
                ord_info[field_name] != undefined &&
                ord_info[field_name].class != undefined) {
                className += ' ' + ord_info[field_name].class;
            }

            return className;
        },
        getClassByColumnInfo(colInfo) {
            let className = 'cell data-header';
            if (typeof colInfo == 'object') {
                if (colInfo.class != undefined && colInfo.class) {
                    className += " " + colInfo.class;
                }
            }

            return className;
        },
        getMobilePartisippHeaderColspan() {
            let value = 2;

            if (this.norskOrdbank != undefined &&
                this.norskOrdbank.paradigme_length != undefined)
            {
                value = this.norskOrdbank.paradigme_length + 1;
            }

            return value;
        },
        getMobileHeaderColspan() {
            let value = 1;

            if (this.norskOrdbank != undefined &&
                this.norskOrdbank.paradigme_length != undefined)
            {
                value = this.norskOrdbank.paradigme_length + 1;
            }

            return value;
        },
        getMobileHeaderClass() {
            let className = "header m-header";
            if (this.norskOrdbank.meta.group_m_length != undefined &&
                this.norskOrdbank.meta.group_m_length > 0) {
                className += " colspan-" + (this.norskOrdbank.meta.group_m_length + 1);
            }

            return className;
        },
        getMobileSpacerClass() {
            let className = "mobile-spacer";
            if (this.norskOrdbank.meta.group_m_length != undefined &&
                this.norskOrdbank.meta.group_m_length > 0) {
                className += " colspan-" + (this.norskOrdbank.meta.group_m_length + 1);
            }

            return className;
        },
        getMobileCellColClassByColumnInfo(colInfo) {
            let className = 'cell cell-col';

            if (colInfo.class != undefined && colInfo.class) {
                className += " " + colInfo.class;
            }

            if (colInfo.show != undefined && colInfo.show == false) {
                className += " hide-desktop";
            }

            return className;
        },
        getMobileClassByColumnInfo(colInfo) {
            let className = 'cell';
            if (colInfo.class != undefined && colInfo.class) {
                className += " " + colInfo.class;
            }

            if (colInfo.colspan != undefined && colInfo.colspan) {
                className += " colspan-" + colInfo.colspan;
            }

            if (colInfo.show != undefined && colInfo.show == false) {
                className += " hide-desktop";
            }

            return className;
        },
        getBlockDivClass(word_index, field_name) {
            let className = 'cell';
            if (this.norskOrdbank.list[word_index][field_name] != undefined) {
                let colInfo = this.norskOrdbank.list[word_index][field_name];
                if (colInfo.class != undefined && colInfo.class) {
                    className += " " + colInfo.class;
                }

                if (colInfo.rowspan != undefined && colInfo.rowspan) {
                    className += " rowspan-" + colInfo.rowspan;
                }

                if (colInfo.show != undefined && colInfo.show == false) {
                    className += " hide-desktop";
                }
            }

            return className;
        },
        getOrdbankId(norskOrdbank, name) {
            let value = name;

            if (typeof norskOrdbank == "object" && norskOrdbank.lemma_id != undefined) {
                value += "-" + norskOrdbank.lemma_id;
            }

            if (this.norskOrdbankIndex != undefined) {
                value += "-" + this.norskOrdbankIndex;
            }

            return value;
        },
        getMetaGridClass(groupName){
            let className = 'grid-table';
            if (this.norskOrdbank.meta.group_length != undefined) {
                let groupLength = this.norskOrdbank.meta.group_length[groupName] || 0;
                if (groupLength) {
                    className += ' g-col-' + groupLength;
                }
            }

            if (this.norskOrdbank.ordklasse == 'adjektiv' ||
                this.norskOrdbank.ordklasse == 'adverb' ||
                this.norskOrdbank.ordklasse == 'personlig pronomen' ||
                this.norskOrdbank.ordklasse == 'spørrepronomen' ||
                this.norskOrdbank.ordklasse == 'determinativ possessiv' ||
                this.norskOrdbank.ordklasse == 'determinativ demonstrativ' ||
                this.norskOrdbank.ordklasse == 'determinativ kvantor') {
                className += ' g-m-col-2';
            }

            return className;
        },
        getMobileMetaGridClass(){
            let className = 'grid-table';
            if (this.norskOrdbank.meta.group_m_length != undefined) {
                let groupLength = (this.norskOrdbank.meta.group_m_length || 0 ) + 1;
                if (groupLength) {
                    className += ' g-col-' + groupLength;
                }
            }

            return className;
        },
        getOrdInfoRowspan(ordInfo) {
            let rowSpan = 1;

            if (typeof ordInfo == "object" && ordInfo.rowspan != undefined) {
                rowSpan = ordInfo.rowspan;
            }

            return rowSpan;
        },
        hasOrdInfoFields(ordInfo, fieldList) {
            if (typeof ordInfo === "object") {
                for (let i in fieldList) {
                    let fieldVal = fieldList[i];
                    if (ordInfo[fieldVal] === undefined) {
                        return false;
                    }
                }
            } else {
                return false;
            }

            return true;
        },
        getOrdInfoClass(ordInfo) {
            let className = '';

            if (typeof ordInfo == "object" && ordInfo.class != undefined) {
                className = ordInfo.class;
            }

            return className;
        },
        getOrdbankSpeakerId(word_index, fieldName) {
            let id = this.getOrdbankId(this.norskOrdbank, "ordbank-speaker-id");
            id += "-" + word_index.toString() + "-" + fieldName.toString();

            return id;
        },
        getLemmaIdList(lemmaList) {
            let value = '';
            for (let key in lemmaList) {
                if (value) {
                    value += ", ";
                }
                value += key;
            }

            return value;
        },
        listHasElements(list) {
            let value = false;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = true;
            }

            return value;
        },
        isFirstInList(rows, row_index) {
            if (typeof rows == "object") {
                for (let i in rows) {
                    if (i == row_index) {
                        return true;
                    }
                    break;
                }
            }

            return false;
        },
        listLength(list) {
            let value = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = Object.keys(list).length;
            }

            return value;
        },
        isOrdbankWordClass(norskOrdbank, ordklasse) {
            let value = false;

            if (norskOrdbank.ordklasse != undefined && norskOrdbank.ordklasse == ordklasse) {
                value = true;
            }

            return value;
        },
        handleMouseOver(mouseOver, rootElementId, className) {
            if (mouseOver) {
                $("#" + rootElementId).addClass(className);
            } else {
                $("#" + rootElementId).removeClass(className);
            }
        },
        showAdjectiveHeader(groupName, fieldName) {
            let value = false;
            if (this.norskOrdbank.meta !== undefined &&
                this.norskOrdbank.meta.group !== undefined &&
                this.norskOrdbank.meta.group[groupName] !== undefined &&
                this.norskOrdbank.meta.group[groupName][fieldName] !== undefined &&
                this.norskOrdbank.meta.group[groupName][fieldName].show !== undefined &&
                this.norskOrdbank.meta.group[groupName][fieldName].show === true
            ) {
                value = true;
            }

            return value;
        },
        showAdjectiveDegreeHeader(fieldName) {
            let value = false;
            if (this.norskOrdbank.meta !== undefined &&
                this.norskOrdbank.meta.group !== undefined &&
                this.norskOrdbank.meta.group.gradboying !== undefined &&
                this.norskOrdbank.meta.group.gradboying[fieldName] !== undefined &&
                this.norskOrdbank.meta.group.gradboying[fieldName].show !== undefined &&
                this.norskOrdbank.meta.group.gradboying[fieldName].show === true
            ) {
                value = true;
            }

            return value;
        },
        getAdjectiveDegreeHeaderLength() {
            let value = 3;
            if (this.norskOrdbank.meta !== undefined &&
                this.norskOrdbank.meta.group !== undefined &&
                this.norskOrdbank.meta.group.gradboying !== undefined) {
                let gradboyingList = this.norskOrdbank.meta.group.gradboying;
                let colspan = 0;
                let fields = ['grunnform', 'grad_komparativ', 'grad_superlativ'];
                for (let i in fields) {
                    if (gradboyingList[fields[i]] !== undefined &&
                        gradboyingList[fields[i]]['show'] !== undefined &&
                        gradboyingList[fields[i]]['show'] === true) {
                        colspan += 1;
                    }
                }
                value = colspan;
            }

            return value;
        },
        showOrdbankWordDataTableColumn(column, fieldName, verifyMeta = true) {

            if ( verifyMeta == true &&
                this.norskOrdbank.meta != undefined &&
                this.norskOrdbank.meta.column != undefined &&
                this.norskOrdbank.meta.column[fieldName] != undefined &&
                this.norskOrdbank.meta.column[fieldName].show != undefined &&
                this.norskOrdbank.meta.column[fieldName].show == false) {
                return false;
            }

            if (typeof column == "object" &&
                column[fieldName] != undefined &&
                column[fieldName].show != undefined &&
                column[fieldName].show == false) {
                return false;
            }

            return true;
        },
        showOrdbankWordDataColumn(fieldName, ord_info = false) {
            let value = true;
            if (typeof this.norskOrdbank == "object" &&
                this.norskOrdbank["meta"]["column"][fieldName] != undefined &&
                this.norskOrdbank["meta"]["column"][fieldName]["show"] != undefined &&
                this.norskOrdbank["meta"]["column"][fieldName]["show"] == false) {
                value = false;
            }

            if (typeof ord_info == "object" &&
                ord_info.show != undefined &&
                ord_info.show == false
            ) {
                value = false;
            }

            return value;
        },
        isKloyvdInfinitiv(ord_info) {
            let value = false;
            if (typeof ord_info == "object" && ord_info.oppslag_list != undefined) {
                for (let i in ord_info.oppslag_list) {
                    let oppslag = ord_info.oppslag_list[i].trim();
                    for (let lemId in this.norskOrdbank.kloyvd_infinitiv) {
                        for (let boyNr in this.norskOrdbank.kloyvd_infinitiv[lemId]) {
                            let val = this.norskOrdbank.kloyvd_infinitiv[lemId][boyNr]['value'];
                            if (val) {
                                let oppslag_kloyvd = this.norskOrdbank.kloyvd_infinitiv[lemId][boyNr]['oppslag'];
                                if (oppslag == oppslag_kloyvd) {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }

            return value;
        },
        showVerbPartisipp() {
            let value = false;
            if (this.norskOrdbank !== undefined &&
                this.norskOrdbank.meta !== undefined &&
                this.norskOrdbank.meta.partisipp !== undefined &&
                this.norskOrdbank.meta.partisipp.show !== undefined &&
                this.norskOrdbank.meta.partisipp.show === true) {
                value = this.showAdditionalInflection();
            }
            return value;
        },
        showAdditionalInflection() {
            let value = true;
            if (this.norskOrdbank !== undefined &&
                this.norskOrdbank.lemma_settings !== undefined &&
                this.norskOrdbank.lemma_settings.hide_additional !== undefined &&
                this.norskOrdbank.lemma_settings.hide_additional === true) {
                value = false;
            }

            return value;
        },
        getMobileKloyvdInfinitivParams() {
            return {
                'is_mobile': true
            };
        },
        ordbankVerbClass() {
            let className = "ordbank-verb";
            if (!this.showVerbPerfektumPartisipp()) {
                className += " auto-width";
            }
            return className;
        },
        getVerbHeaderPartisippClass() {
            let className = "header";
            let colspan = 4;
            if (this.norskOrdbank.meta == undefined ||
                this.norskOrdbank.meta.column == undefined
            ) {
                return className;
            }

            if (this.norskOrdbank.meta.column.partisipp_hanhun.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_hanhun.show == false) {
                colspan--;
            }

            if (this.norskOrdbank.meta.column.partisipp_intet.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_intet.show == false) {
                colspan--;
            }

            if (this.norskOrdbank.meta.column.partisipp_bestemt.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_bestemt.show == false) {
                colspan--;
            }

            if (this.norskOrdbank.meta.column.partisipp_flertall.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_flertall.show == false) {
                colspan--;
            }

            if (colspan > 0) {
                className += " colspan-" + colspan;
            }

            return className;
        },
        getVerbHeaderPartisippColspan() {
            let colspan = 4;
            if (this.norskOrdbank.meta == undefined ||
                this.norskOrdbank.meta.column == undefined
            ) {
                return colspan;
            }

            if (this.norskOrdbank.meta.column.partisipp_hanhun.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_hanhun.show == false) {
                colspan--;
            }

            if (this.norskOrdbank.meta.column.partisipp_intet.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_intet.show == false) {
                colspan--;
            }

            if (this.norskOrdbank.meta.column.partisipp_bestemt.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_bestemt.show == false) {
                colspan--;
            }

            if (this.norskOrdbank.meta.column.partisipp_flertall.show != undefined &&
                this.norskOrdbank.meta.column.partisipp_flertall.show == false) {
                colspan--;
            }


            return colspan;
        },
        showVerbPerfektumPartisipp() {
            let value = false;
            if (typeof this.norskOrdbank == "object"){
                const fields = [
                    'partisipp_hanhun',
                    'partisipp_intet',
                    'partisipp_bestemt',
                    'partisipp_flertall'
                ];

                for (let fieldNameIndex in fields) {
                    let fieldName = fields[fieldNameIndex];
                    if ((this.norskOrdbank["meta"]["column"][fieldName] || false) &&
                        this.norskOrdbank["meta"]["column"][fieldName]["show"] == true) {
                        return true;
                    }
                }
            }

            return value;
        },
        hasMetaShowCol(fieldName) {
            let value = false;
            if (typeof this.norskOrdbank == "object") {
                if ((this.norskOrdbank["meta"]["column"][fieldName]["show"] || false) &&
                    this.norskOrdbank["meta"]["column"][fieldName]["show"] == true) {
                    value = true;
                }
            }

            return value;
        },
        getAdjectiveDesktopBlockClass() {
            let colspan = parseInt(this.getAdjektivDesktopHeaderColspan());
            if (this.hasMetaShowCol('flertall')) {
                colspan = colspan + 1;
            }
            let value = 'ordbank-table desktop adj-col-' + colspan;

            return value
        },
        getAdjektivDesktopHeaderColspan() {
            let value = 0;
            let counter = 0;

            let fieldList = ['entall_han', 'entall_hun', 'entall_hanhun', 'entall_intet', 'entall_bestemt'];
            for (let i in fieldList) {
                let field_name = fieldList[i];
                if (this.hasMetaShowCol(field_name)) {
                    counter += 1;
                }
            }

            value = counter.toString();

            return value;
        },
        getAdjektivDesktopHeaderClass() {
            let value = "header colspan-";
            let counter = 0;
            let fieldList = ['entall_hanhun', 'entall_intet', 'entall_bestemt'];
            for (let i in fieldList) {
                let field_name = fieldList[i];
                if (this.hasMetaShowCol(field_name)) {
                    counter += 1;
                }
            }

            value += counter.toString();

            return value;
        },
        showOrdbankWordDataCell(wordData, fieldName) {
            let value = false;

            if (typeof wordData == "object" &&
                wordData[fieldName] != undefined &&
                wordData[fieldName]["show"] != undefined) {
                value = wordData[fieldName]["show"];
            }

            return value;
        },
        getKjoennTranslationCode(kjoenn_header_code) {
            let value = "message.ordbank_kjoenn_" + kjoenn_header_code;

            return value;
        },

        getBoyingResult() {
            let boyingResult = {
                'headers': this.norskOrdbank["headers"] || [],
                'rows': this.norskOrdbank["rows"] || [],
                'inflection_rows': this.norskOrdbank["inflection_rows"] || [],
                'inflection_rows_additional': this.norskOrdbank["inflection_rows_additional"] || [],
                'header': this.norskOrdbank["header"] || "",
                'sub_header': this.norskOrdbank["sub_header"] || "",
                'sub_header_list': this.norskOrdbank["sub_header_list"] || [],
            };

            return boyingResult;
        },

        getOrdbankTableBlockClass(groupName, classValue) {
            let counter = 0;

            if (this.norskOrdbank.meta != undefined &&
                this.norskOrdbank.meta.group != undefined &&
                this.norskOrdbank.meta.group[groupName] != undefined) {
                for (let i in this.norskOrdbank.meta.group[groupName]) {
                    if (this.norskOrdbank.meta.group[groupName][i].show != undefined &&
                        this.norskOrdbank.meta.group[groupName][i].show == true) {
                        counter += 1;
                    }
                }
            }

            classValue += ' column-' + counter;

            return classValue;
        },

        getSubstantivHeaderByCode(code) {
            let value = '';
            if (code == 'mask') {
                value = this.$t("message.ordbank_kjoenn_mask");
            } else if (code == 'fem') {
                value = this.$t("message.ordbank_kjoenn_fem");
            } else if (code == 'noeyt') {
                value = this.$t("message.ordbank_kjoenn_noeyt");
            }

            return value;
        },

        getSubstantivHeader() {
            let value = '';
            if (typeof this.norskOrdbank == "object") {
                if (this.listLength(this.norskOrdbank.list) == 3) {
                    value = this.$t("message.ordbank_kjoenn_mask") + ", " +
                        this.$t("message.ordbank_kjoenn_fem") + " " +
                        this.$t("message.ordbank_or") + " " +
                        this.$t("message.ordbank_kjoenn_noeyt")
                } else if (this.listLength(this.norskOrdbank.list) <= 2) {
                    for (let lang_code in this.norskOrdbank.list) {
                        if (value) {
                            value += " " + this.$t("message.ordbank_or") + " ";
                        }
                        value += this.$t(this.getKjoennTranslationCode(lang_code));
                    }
                }
            }

            return value;
        },

        hasResultRowFields(row, field_list) {
            if (typeof row == "object") {
                for (let i in field_list) {
                    let field_name = field_list[i];
                    if (row[field_name] == undefined) {
                        return false;
                    }
                }
            }
            return true;
        },

        isEmptyValue(content) {
            let value = false;
            content = content.trim();

            if (content == "" || content == '-') {
                value = true;
            }

            return value;
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleCloseDialogClick);
        document.removeEventListener('keydown', this.handleCloseDialogClick);
    }
}
</script>
